import {
  Box,
  Menu,
  MenuItem,
  MenuItemDescription,
  MenuItemLabel,
} from "@aircall/tractor";
import { useNavigate } from "react-router";

import { ScoreCardLocationState } from "../EvaluationNew";
import { ScrollShadowContainer } from "../ScrollShadowContainer";

import { ScoreCardFragment } from "@/graphql/generated/graphql";
import styled from "@xstyled/styled-components";
import { ScoreCardMenuProps } from ".";

// Tractor sets the height to be 48px by default.
const StyledMenuItem = styled(MenuItem)`
  min-height: 48px;
  height: auto;
  overflow: auto;
`;

export function ScoreCardMenu({ data, onClickItem }: ScoreCardMenuProps) {
  const navigate = useNavigate();

  const handleOnClick = (scoreCard: ScoreCardFragment) => () => {
    onClickItem(scoreCard);
    navigate("../new", {
      state: {
        scoreCardId: scoreCard.ID,
      } as ScoreCardLocationState,
    });
  };

  return (
    <ScrollShadowContainer
      borderRadius="default"
      backgroundColor="surface-background"
      p="s"
      mt="xs"
      overflow="auto"
      maxH="100%"
    >
      <Menu>
        {data.map((scoreCard, index) => (
          <Box
            key={scoreCard.ID}
            border="1px solid"
            borderColor="graphic-default"
            borderRadius="sm"
            overflow="hidden"
            mb="xxs"
          >
            <StyledMenuItem
              onClick={handleOnClick(scoreCard)}
              data-test={`score-card-menu-item-${index}`}
            >
              <MenuItemLabel>{scoreCard.name}</MenuItemLabel>
              <MenuItemDescription>{scoreCard.description}</MenuItemDescription>
            </StyledMenuItem>
          </Box>
        ))}
      </Menu>
    </ScrollShadowContainer>
  );
}
